import React from "react";
import TravelExpenseApprovalRow from "./TravelExpenseApprovalRow";

const TravelExpenseApprovalTable = ({
  records,
  selectedIds,
  openingReceiptUrl,
  refreshingFlowId,
  allSelectableChecked,
  someSelectableChecked,
  onToggleSelectAll,
  onToggleSelect,
  onOpenReceiptModal,
  onApprove,
  onReject,
  onRefreshFlow,
  onDelete,
}) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm transition-colors duration-300">
      <table className="w-full text-left text-sm">
        <thead className="bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300 text-xs uppercase tracking-wide">
          <tr>
            <th className="px-4 py-3 text-center font-semibold">
              <input
                type="checkbox"
                checked={allSelectableChecked}
                ref={(input) => {
                  if (input) {
                    input.indeterminate =
                      someSelectableChecked && !allSelectableChecked;
                  }
                }}
                onChange={onToggleSelectAll}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                aria-label="Select all receipts"
              />
            </th>
            <th className="px-4 py-3 font-semibold">วันที่เดินทาง</th>
            <th className="px-4 py-3 font-semibold">ผู้ขอ</th>
            <th className="px-4 py-3 font-semibold">QT / โครงการ</th>
            <th className="px-4 py-3 font-semibold">ต้นทาง</th>
            <th className="px-4 py-3 font-semibold">ปลายทาง</th>
            <th className="px-4 py-3 text-right font-semibold">จำนวนเงินรวม</th>
            <th className="px-4 py-3 text-center font-semibold">หลักฐาน</th>
            <th className="px-4 py-3 text-center font-semibold">Approval Flow</th>
            <th className="px-4 py-3 text-center font-semibold">สถานะ</th>
            <th className="px-4 py-3 text-center font-semibold">Actions</th>
          </tr>
        </thead>

        <tbody>
          {records.length > 0 ? (
            records.map((item, index) => (
              <TravelExpenseApprovalRow
                key={item._id}
                item={item}
                index={index}
                checked={selectedIds.includes(item._id)}
                openingReceiptUrl={openingReceiptUrl}
                refreshingFlowId={refreshingFlowId}
                onToggleSelect={onToggleSelect}
                onOpenReceiptModal={onOpenReceiptModal}
                onApprove={onApprove}
                onReject={onReject}
                onRefreshFlow={onRefreshFlow}
                onDelete={onDelete}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={11}
                className="px-4 py-8 text-center text-gray-500 dark:text-gray-400"
              >
                ไม่พบรายการเบิกค่าเดินทาง
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TravelExpenseApprovalTable;
